export default "__VITE_ASSET__CCcozTOu__"